import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Guard to protect routes that should only be accessible to external users.
 * Redirects unauthorized users to the landing page.
 */
@Injectable({
  providedIn: 'root',
})
export class ExUserGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // Build validation is now handled during loadUserSession()
    if (!this.authService.isExternalUser()) {
      return this.router.createUrlTree(['', 'landing']);
    }

    return true;
  }
}
